import { connectRoutes } from 'redux-first-router'
import queryString from 'query-string'

import {
  routeToHome,
  routeToOnDemand,
  routeToInstalledAgent,
  routeToClassroomAgent,
} from '../actions/routing'

const routesMap = {
  [routeToHome]: '/',
  [routeToOnDemand]: '/ondemand/:sessionKey',
  [routeToInstalledAgent]: '/agent/:id',
  [routeToClassroomAgent]: '/classroom/:id',
}

const options = {
  initialDispatch: true,
  querySerializer: queryString
}

export const { reducer, middleware, enhancer, initialDispatch } = connectRoutes(routesMap, options)
